import MockLeagues from '../../mocks/leagues.json';
import ResponseLeagues from './interface';

export const LeaguesAPI = {
  getLeagues: async () => {
    return <ResponseLeagues>MockLeagues;
  },
};

export * from './interface';
